import { TAction, TDispatch } from "../../../types";
import {
  ConfigureUnitPIAction,
  ConfigureUnitPIActionType,
  ConfigureUnitPIMainDataModel,
  ConfigureUnitPIModel,
} from "./types";
import { fetchAPI } from "../../../../config/axios";

export const ConfigureUnitPIDefault: ConfigureUnitPIModel = {
  main: {
    data: [],
    total: 0,
  },
};

export const ConfigureUnitPIReducer = (
  state: ConfigureUnitPIModel = ConfigureUnitPIDefault,
  action: ConfigureUnitPIAction
): ConfigureUnitPIModel => {
  switch (action.type) {
    case ConfigureUnitPIActionType.GetUnitPIMain:
      return { ...state, main: action.data };

    default:
      return { ...state };
  }
};

export const ConfigureUnitPICommand = {
  GetUnitPIMainData: (params: unknown): TAction<ConfigureUnitPIAction, void> => {
    return (dispatch: TDispatch<ConfigureUnitPIAction>) => {
      return fetchAPI().get('/unit-performances', { params }).then((response) => {
        dispatch({
          data: {
            data: response.data.data.data,
            total: response.data.data.total,
          },
          type: ConfigureUnitPIActionType.GetUnitPIMain,
        });
      });
    };
  },
  DownloadTemplateEntityPI: (): TAction<ConfigureUnitPIAction, void> => {
      return async (dispatch: TDispatch<ConfigureUnitPIAction>) => {
        const response = await fetchAPI().get('/unit-performance/download/template?filename=template_a', {
          responseType: 'blob', // Set responseType to 'blob' to handle binary data
        });
  
        // Create a blob from the response data
        const blob = new Blob([response.data], { type: response.headers['content-type'] });
  
        // Create a link element
        const link = document.createElement('a');
  
        // Set the download attribute and create a URL for the blob
        link.href = window.URL.createObjectURL(blob);
        link.download = 'template_sasaran_bidang.xlsx'; // Set the desired file name
  
        // Append the link to the document body and programmatically click it
        document.body.appendChild(link);
        link.click();
  
        // Remove the link from the document body
        document.body.removeChild(link);
      };
    },
    ExportEntityPI: (): TAction<ConfigureUnitPIAction, void> => {
        return async (dispatch: TDispatch<ConfigureUnitPIAction>) => {
          const response = await fetchAPI().get('/unit-performance/export/xlsx', {
            responseType: 'blob', // Set responseType to 'blob' to handle binary data
          });
    
          // Create a blob from the response data
          const blob = new Blob([response.data], { type: response.headers['content-type'] });
    
          // Create a link element
          const link = document.createElement('a');
    
          // Set the download attribute and create a URL for the blob
          link.href = window.URL.createObjectURL(blob);
          link.download = 'sasaran_bidang_data.xlsx'; // Set the desired file name
    
          // Append the link to the document body and programmatically click it
          document.body.appendChild(link);
          link.click();
    
          // Remove the link from the document body
          document.body.removeChild(link);
        };
      },
};
